import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

const PublicOnly = () => {
  const { isHydrated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const manualLogout = window.sessionStorage.getItem('sf-manual-logout') === '1';
    if (manualLogout && location.search.includes('redirectTo=')) {
      window.sessionStorage.removeItem('sf-manual-logout');
      navigate('/login', { replace: true });
    }
  }, [location.search, navigate]);

  if (!isHydrated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-default text-text-primary">
        <div className="animate-pulse text-sm text-text-muted">Loading session…</div>
      </div>
    );
  }

  return <Outlet />;
};

export default PublicOnly;
